export default __webpack_public_path__ + "static/media/undraw_blank_canvas_3rbb.d2e14e8e.svg";